import React from 'react';
export default class RefreshDataSpinner extends React.Component {
    render() {
        {
            return this.props.loading ? (React.createElement("div", { className: "-loading -active" },
                React.createElement("div", { className: "-loading-inner" },
                    React.createElement("i", { className: "fa fa-spinner fa-spin fa-3x fa-fw" }),
                    React.createElement("span", { className: "sr-only" }, "Loading...")))) : null;
        }
    }
}
